import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IEarlyAccessContactsState {
  offerId: number | null;
}

const initialState: IEarlyAccessContactsState = {
  offerId: null,
};

export const earlyAccessContactsSlice = createSlice({
  name: 'earlyAccessContacts',
  initialState,
  reducers: {
    clearOfferId: state => {
      state.offerId = null;
    },
    requestContactsAccessCheck: (state, action: PayloadAction<number>) => {
      state.offerId = action.payload;
    },
  },
});

export const { clearOfferId, requestContactsAccessCheck } = earlyAccessContactsSlice.actions;
export const earlyAccessContactsReducer = earlyAccessContactsSlice.reducer;

export type TEarlyAccessContactsActions =
  | ReturnType<typeof clearOfferId>
  | ReturnType<typeof requestContactsAccessCheck>;
